/**
 * Created by Rodrigo Quesada on 17/02/17.
 */
import {IdentifiedModel} from '../../../../domain/model/common/identified-model.class';
import {Response} from '@angular/http';
import {FileLocation, FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {Model} from '../../../../domain/model/common/model.class';
import {Injectable} from '@angular/core';
import ProjectionInformation = Model.ProjectionInformation;

export interface Entry<M extends IdentifiedModel<M>> {
    model: M;

    update(response: Response): void;
}

export class DefaultEntry<M extends IdentifiedModel<M>> implements Entry<M> {
    constructor(readonly model: M) {}

    update(response: Response): void {
        if (!this.model.id) this.model.id = response.text();
    }
}

export class EntryWithSupportingDocument<M extends IdentifiedModel<M>> extends DefaultEntry<M> {

    supportingDocumentFileLocation?: FileLocation;

    constructor(private readonly _esdm: EntryWithSupportingDocument.InjectedMembers, model: M, private readonly _fileLocationNamespace: string) {
        super(model);
        this.supportingDocumentFileLocation = this._fileLocation();
    }

    private _fileLocation(): FileLocation | undefined {
        if (this.model.id) return this._esdm.fileLocationFactory.create(this._fileLocationNamespace, this._filePath(), new ProjectionInformation('supportingDocument'));
    }

    private _filePath(): string { return `currentUser/${this.model.id}`; }

    update(response: Response): void {
        super.update(response);
        if (!this.supportingDocumentFileLocation) this.supportingDocumentFileLocation = this._fileLocation();
    }
}

// region Entry Injection
export module EntryWithSupportingDocument {
    @Injectable()
    export class InjectedMembers {
        constructor(readonly fileLocationFactory: FileLocationFactory) {
        }
    }
}
// endregion



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/shared/step/accordion/entry.class.ts